var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('input',{ref:"input",staticStyle:{"display":"none"},attrs:{"accept":_vm.accept,"type":"file"},on:{"change":_vm.onFileSelected}}),_c('bcc-button',{staticStyle:{"padding":"8px 12px!important"},attrs:{"size":"small"},on:{"click":function($event){return _vm.uploadQuestionnaire($event)}}},[_vm._v(" "+_vm._s(_vm.btnTxt)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }